module.exports = __webpack_public_path__ + "img/phone.9f9c8ead.jpg";